import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import { fetchCaseDamages,send_email } from "./store/actions";
import "./BasicDamageReport.css";
import { requestCaseLoad } from "../../Purchases/store/actions";
import ArtificialInflationGraphContainer from "../../../common/components/ArtificialInflationGraph/ArtificialInflationGraphContainer";
import RiskArtificialInflationGraphContainer from "../../../common/components/RiskArtificialInflationGraph/RiskArtificialInflationGraphContainer";
import StockPriceOfferingGraphContainer from "../../../common/components/StockPriceOfferingGraph/StockPriceOfferingGraphContainer";
import ClassPeriodTradingStatContainer from "../../../common/components/ClassPeriodTradingStat/ClassPeriodTradingStatContainer";
import MarketCapLossesContainer from "../../../common/components/MarketCapLosses/MarketCapLossesContainer";
import AdverseCorporateEventExposureContainer from "../../../common/components/AdverseCorporateEventExposure/AdverseCorporateEventExposureContainer";
import StatAnalysisContainer from "../../../common/components/StatAnalysis/StatAnalysisContainer";
import RiskStatAnalysisContainer from "../../../common/components/RiskStatAnalysis/RiskStatAnalysisContainer";
import ClassPeriodOfferingsContainer from "../../../common/components/ClassPeriodOfferings/ClassPeriodOfferingsContainer";
import OfferingExposureContainer from "../../../common/components/OfferingExposure/OfferingExposureContainer";
import { Button } from "../../../common/components/Button";
import { numTo2DecimalsPercent } from "../../../util";
import Modal from "react-responsive-modal";
import { FaTimes } from "react-icons/fa";
import Disclosure from "../../../ace/Disclosure";
import axios from "axios";
import { apiUri } from "../../../config";
import { dandoForm } from "../../../dandos/redux/actions";
import TermsAndConditions from "../../../ace/TermsAndConditions";

const ButtonHolder = styled.div`
	margin-top: 10px;
`;
const RightSideButton = styled(Button)`
	float: right;
`;

const LeftSideButton = styled(Button)`
	marginright: 15px;
`;


class BasicDamageReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openBlock: false,
			viewerModal: false,
			openAceModal : false
		};
	}
	componentDidMount() {
		let caseId = this.props.match.params.caseId;
		this.props.fetchCaseAndPurchases(caseId);
		localStorage.removeItem("searchValue");
		//localStorage.removeItem("sortParams");
		this.setState({
			isAdminToken:
				localStorage.getItem("isAdminToken") === "false" ? false : true,
		});

		this.setState({
			buttonDisableForCommission: sessionStorage.getItem("Type"),
		});
	}

	redirectToPurchaseOrClassWide = (purchased) => {
		let caseId = this.props.currentCaseId;
		if (this.state.isAdminToken) {
			this.props.history.push("/cases/" + caseId + "/classwide");
		} else {
			if (purchased || sessionStorage.getItem("DANDO") === "true") {
				this.props.history.push("/cases/" + caseId + "/classwide");
			} else {
				this.props.history.push("/cases/" + caseId + "/purchase");
			}
		}
	};

	sendAceAlertEmail = () => {
		let caseId = this.props.match.params.caseId;
		let dandoDetails = {
			company_name:this.props.currentCase.fillingName,
			ticker:this.props.currentCase.symbol,
			risk_assessment_date:new Date(),
			notes:this.props.currentCase.notes?this.props.currentCase.notes:''

		}

		this.props.dandoForm(dandoDetails);
		if (this.props.firmSettings.risk) {
			this.props.history.push("/dandos/create");
		} else {
			axios
				.get(apiUri + `/alert/sendInternalMailonRequest/${caseId}`)
				.then((json) => {
					// this.props.send_email('');
					if (json.data.statusCode === 200) {
						this.setState({ ...this.state, openBlock: true });
					}
				})
				.catch((error) => {
					console.error(">>>>>:::::::::", error);
				});
		}
	};
	createRisk() {
		let caseId = this.props.match.params.caseId;
		this.props.history.push("/dandos/create/" + caseId);
	}

	onCloseAceModal = () => {
		this.setState({ open: false, openAceModal: false });
	};

	subscribeAce() {
		let caseId = this.props.match.params.caseId;
		if(this.props.currentCase.canSubscribeAlert && this.props.currentCase.canSubscribeAlert === true) {
			axios
				.post(apiUri + `/alert/fromCase/${caseId}`)
				.then((json) => {
					// this.props.send_email('');
					if (json.data.statusCode === 201) {
						this.setState({ ...this.state, openAceModal: false });
						this.props.fetchCaseAndPurchases(caseId);
					}
				})
				.catch((error) => {
					console.error(">>>>>:::::::::", error);
				});
		}

	}
	//
	handleViewer = (viewerFileURL, viewerFileType) => {

		let myURL = "https://docs.google.com/viewer?url="+encodeURIComponent(viewerFileURL)+"&embedded=true";
		if(viewerFileType === 'xlsx')
			myURL = "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(viewerFileURL);
			

		this.setState({viewerFileUrl: myURL});
		this.setState({ viewerModal: true});
		
	};
	
	onCloseViewerModal = () => {
		this.setState({ viewerModal: false, viewerFileUrl : "" });
	};

	onCloseBlockModal = () => {
		this.setState({ openBlock: false });
	};
	render() {
		//console.log("this.props");
		//console.log(this.props);
		let usExchange = true;
		if(this.props.currentCase.market == "TSX")
			usExchange = false;
		
		if (!this.props.boughtCases) {
			return <div>Loading</div>;
		}
		let goToClassWideButton = "";
	
		const alreadyPurchased = this.props.boughtCases.filter(x => x === this.props.currentCaseId).length !== 0;
		let goToClassWideButtonDisabled = !alreadyPurchased;
		if (
			(
				this.props.currentCase.availablePurchaseLevels &&
				this.props.currentCase.availablePurchaseLevels.length > 0
			) ||
			this.props.currentCase.availablePurchaseLevels == null
		) {
			goToClassWideButtonDisabled = false;
		}
		// AceALerts Conditions
		
		let viewButton =''
		if(this.props.currentCase.claimTypeId === 4) {
			
			
			viewButton ='License Risk Report'
			if ( localStorage.getItem("isAdminToken") !== "true") {
				goToClassWideButton = (
					<Button
						disabled={goToClassWideButtonDisabled}
						onClick={() => this.sendAceAlertEmail(alreadyPurchased)}
					>
						{viewButton}
					</Button>);
			} else {
					goToClassWideButton = '';
			}
		// Dando pervious Conditions
		} else if (!usExchange) {
			goToClassWideButton = '';
		} else {
			viewButton = this.props.currentCase.claimTypeId === 3?"View Risk Severity Analysis":"View Severity";
			if (localStorage.getItem("isAdminToken") === "true") {
				
				goToClassWideButton = (
					<Button
						disabled={goToClassWideButtonDisabled}
						onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
					>
						
							{viewButton}

					</Button>
				);
			} else {
				if(this.state.buttonDisableForCommission==="COMMISSION"){
					goToClassWideButton = (
						<Button
							disabled={goToClassWideButtonDisabled}
							onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
						>
							{viewButton}
						</Button>
					);
				} else {
					
					if (alreadyPurchased) {
						goToClassWideButton = (
							<Button
								disabled={goToClassWideButtonDisabled}
								onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
							>

								{viewButton}

							</Button>
						);
					} else {
						goToClassWideButton = (
							<Button
								disabled={goToClassWideButtonDisabled}
								onClick={() => this.redirectToPurchaseOrClassWide(alreadyPurchased)}
							>
								Commission Aggregate Damages Estimate
							</Button>
						);
					}
				}
			}
		}
		return (
			<React.Fragment>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div className={"PageHeader"}>
						<span className={"PageHeaderText"}>
							{this.props.currentFillingName}{" "}
						</span>
						{
						this.props.currentCase.claimTypeId != null && 
						(
							this.props.currentCase.claimTypeId === 3 || 
							this.props.currentCase.claimTypeId === 4 
						) &&
						this.props.currentCase.riskData != null &&
						this.props.currentCase.riskData.riskScore != null ? (
							<span
								className={
									this.props.currentCase.riskData.riskScore < 1
										? "PageHeaderScore"
										: "PageHeaderScore100"
								}
							>
								{numTo2DecimalsPercent(
									this.props.currentCase.riskData.riskScore
								)}
							</span>
						) : (
							""
						)}
					</div>
					<div style={{width:"200px", display: "block"}}>
						<div style={{float: this.props.currentCase.claimTypeId > 2? "right" :  "left"}}>
							{
								(this.props.currentCase.claimTypeId == 1 && this.props.currentCase.complaintFile && this.props.currentCase.complaintFile.length > 4)?	
								
									<Button
										onClick={() => this.handleViewer(this.props.currentCase.complaintFile, 'pdf')}
									>

										View Complaint

									</Button> 
								 : ""
							}
							<span style={{width: "10px;"}} > &nbsp; </span>
							{((this.props.currentCase.stockPrices !== undefined &&
								this.props.currentCase.stockPrices !== null &&
								this.props.currentCase.stockPrices.length > 0) ||
								true) &&
								goToClassWideButton}
						</div>
						{this.props.currentCase.claimTypeId && this.props.currentCase.claimTypeId === 3?

							<div style={{float: "right"}}>
								<Button
									
									onClick={() => this.createRisk()}
								>
									License Updated Risk Report
								</Button>
							</div> :
							""
						}
						{this.props.currentCase.canSubscribeAlert && this.props.currentCase.canSubscribeAlert === true?

							<div style={{float: "right"}}>
								<Button
									
									onClick={() => { this.setState({ openAceModal: true}) }} 
								>
									Subscribe to ACE Alerts
								</Button>
							</div> :
							""
						}
					</div>
				</div>
				{this.state.openBlock && (
					<Modal
						open={this.state.openBlock}
						onClose={this.onCloseBlockModal}
						focusTrapped={true}
						styles={{
							modal: { width: "60%", height: "60%", overflow: "auto" },
						}}
					>
						<div className="ModalWindow modaladd">
							<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
							<br />
							<div className="modalHeading"></div>
							<div className="NavDivider"></div>
							<Disclosure />
							<div className="NavDivider"></div>
							<div>
								<div className="NavDivider"></div>
							</div>
						</div>
					</Modal>
				)}
				{this.state.viewerModal && (
					<Modal
						open={this.state.viewerModal}
						onClose={this.onCloseViewerModal}
						onRequestClose={this.onCloseViewerModal}
						styles={{
							modal: { width: "90%", height: "90%", overflow: "auto" },
						}}
						
					>
						<div>
						<FaTimes className="closeicon"  onClick={this.onCloseViewerModal} />
						</div>
						<div style={{width: "100%", height: "100%", paddingTop:"10px"}} >
						
							<iframe 
								title="View Complaint"
								width="900px"
								height="650px"
								scrolling="auto"
								src={this.state.viewerFileUrl}
								/>
						</div>
					</Modal>
				)}
				{
					this.props.currentCase.claimTypeId === 1 && this.props.currentCase.caseRuleTypeId === 3?
						<div>
							<ClassPeriodOfferingsContainer
								classPeriodOfferings={
									this.props.currentCase.offering
								}
							/>
							<OfferingExposureContainer
								classPeriodOfferings={
									this.props.currentCase.offering
								}
								offeringExposures={
									this.props.currentCase.offeringExposure
								}
							/>
							<StockPriceOfferingGraphContainer
								stockPrices={this.props.currentCase.stockPrices}
								aggregateDamagesNOPSLRA={
									this.props.currentCase.aggregateDamagesNOPSLRA}
								caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
								classPeriodOfferings={
										this.props.currentCase.offering
									}
							/>
							
						</div>
						:
						(
							this.props.currentCase.claimTypeId === 3 && this.props.currentCase.riskStats.length == 2?
							<div>
								<div style={{display: 'table-row'}}>
									<div style={{width: '50%', display: 'table-cell', verticalAlign:'top'}}>
										<ClassPeriodTradingStatContainer
											classPeriodTradingStats={
												this.props.currentCase.classPeriodTradingStats
											}
											claimTypeId={this.props.currentCase.claimTypeId}
										/>
									</div>
									<div style={{width: '50%', display: 'table-cell'}}>
										<RiskStatAnalysisContainer
											riskStats={this.props.currentCase.riskStats}
											claimTypeId={this.props.currentCase.claimTypeId}
										/> 
									</div>
								</div>
								<AdverseCorporateEventExposureContainer
									adverseCorporateEvent={
										this.props.currentCase.adverseCorporateEvent
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<StatAnalysisContainer
									statResidualReturns={this.props.currentCase.statResidualReturns}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<RiskArtificialInflationGraphContainer
									stockPrices={this.props.currentCase.stockPrices}
									adverseCorporateEvents={
										this.props.currentCase.adverseCorporateEvent
									}
									aggregateDamagesNOPSLRA={
										this.props.currentCase.aggregateDamagesNOPSLRA}
									caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
							/>
							</div>
							:
							<div>
								<ClassPeriodTradingStatContainer
									classPeriodTradingStats={
										this.props.currentCase.classPeriodTradingStats
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<MarketCapLossesContainer
									marketCapitalizationLosses={
										this.props.currentCase.marketCapitalizationLosses
									}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>								
								<StatAnalysisContainer
									statResidualReturns={this.props.currentCase.statResidualReturns}
									claimTypeId={this.props.currentCase.claimTypeId}
								/>
								<ArtificialInflationGraphContainer
									stockPrices={this.props.currentCase.stockPrices}
									aggregateDamagesNOPSLRA={
										this.props.currentCase.aggregateDamagesNOPSLRA}
									caseRuleTypeId={this.props.currentCase.caseRuleTypeId}
							/>
							</div>
						)
				}
				
			<Modal
					open={this.state.openAceModal}
					onClose={this.onCloseAceModal}
					focusTrapped={true}
					styles={{ modal: {width: "60%", height: "60%", overflow: "hidden" } }}
				>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.onCloseAceModal} />
						<br />
						<div className="modalHeading">ACE Alert&reg; Terms And Conditions</div>
						<div className="NavDivider"></div>
						
						<TermsAndConditions onScrollToBottom={() => {}} />
						
						<div className="NavDivider"></div>
						<div>
							
							<ButtonHolder>
								<LeftSideButton
									hoverBorderColor="red"
									onClick={() => this.onCloseAceModal()}
								>
									Decline
								</LeftSideButton>
								<RightSideButton
									hoverBorderColor="darkgreen"
									disabled={this.state.buttonDisabled}
									onClick={() =>
										this.subscribeAce()
									}
									>
									Subscribe to ACE
								</RightSideButton>
							</ButtonHolder>
							

						</div>
					</div>
				</Modal>
			</React.Fragment>
		);
	}
	componentWillUnmount(){
		this.props.send_email('');
	}
}

const mapStateToProps = state => {
	return {
		boughtCases: state.ownedCases.boughtCases,
		currentCase: state.currentCase.currentCase,
		currentCaseId: state.currentCase.caseId,
		currentFillingName: state.currentCase.fillingName,
		alertType:state.aceAlerts.alertType,
		firmSettings:state.firmSettings,  
	};
};

const mapDispatchToProps = dispatch => {
	return {
		fetchCaseAndPurchases: caseId => {
			dispatch(fetchCaseDamages(caseId));
			dispatch(requestCaseLoad());
			
		},
		send_email: (alertData)=>dispatch(send_email(alertData)),
		dandoForm:(formData)=>dispatch(dandoForm(formData))
	 
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(BasicDamageReport));



// WEBPACK FOOTER //
// ./src/components/DamageReports/BasicDamageReport/BasicDamageReport.js